import React, { useEffect, useState } from 'react'
import NavbarForProductList from './NavbarProduct';
import { NavLink } from 'react-router-dom';
import Logo from './images/logoimg.jpeg';
import './css/Navbar.css'
import Navbar from './Navbar';

const ProductList = () => {
    const [productList, setProductList] = useState([]);
    const [searchProduct, setSearchProduct] = useState('');
    const showProductList = async () => {

        const req = await fetch(`https://jivichem.herokuapp.com/api/v1/product/productList`);

        const data = await req.json();

        const listOfProduct = data.getProduct;

        setProductList(...productList, listOfProduct);
        console.log(listOfProduct);
    }

    useEffect(() => {
        showProductList();
    }, [])

    return (
        <>
            <nav className="navbar navbar-expand-lg navbar-light bg-light">
                {/* <a className="navbar-brand">
                    <img src={Logo} width="80" height="80" class="d-inline-block align-top" />
                </a> */}
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    {/* <NavLink className="nav block mt-4 lg:inline-block lg:mt-0 text-teal-200 hover:text-white mr-4" to="/">Home</NavLink>
                    <NavLink className="nav block mt-4 lg:inline-block lg:mt-0 text-teal-200 hover:text-white mr-4" to="/product_list">Product</NavLink>
                    <NavLink className="nav block mt-4 lg:inline-block lg:mt-0 text-teal-200 hover:text-white mr-4" to="/download">Download</NavLink>
                    <NavLink className="nav block mt-4 lg:inline-block lg:mt-0 text-teal-200 hover:text-white mr-4" to="/connect">Connect</NavLink>
                    <NavLink className="nav block mt-4 lg:inline-block lg:mt-0 text-teal-200 hover:text-white mr-4" to="/#">Order</NavLink> */}
                    <Navbar />
                    {/* <form className="form-inline mx-20 my-lg-0">
                        <input className="search-in-nav form-control mr-sm-2"
                            type="search"
                            placeholder="Search"
                            onChange={(e) => {
                                setSearchProduct(e.target.value);
                            }}
                            aria-label="Search" />
                    </form> */}
                </div>
            </nav>
            <align className="right">
            </align>
            <table className="center">
                <thead>
                    <tr>
                        <th>
                            <font color="midnightblue">S. No.</font>
                        </th>
                        <th>
                            <font color="midnightblue">Name of the Product</font>
                        </th>
                        <th>
                            <font color="midnightblue">CAS Number</font>
                        </th>
                    </tr>
                </thead>
                <tbody id="myTable">
                    {productList.filter((data) => {
                        if (searchProduct === "") {
                            return data;
                        } else if (data.name.toLowerCase().includes(searchProduct.toLowerCase())||data.cas.includes(searchProduct)) {
                            return data;
                        }
                    }).map((data, i) => (
                        <tr>
                            <td>{i + 1}</td>
                            <td>{data.name}</td>
                            <td>{data.cas}</td>
                        </tr>
                    ))}

                </tbody>
            </table>
        </>
    )
}

export default ProductList;
